import React from "react";
import { ValidationForm } from "react-bootstrap4-form-validation";
import { FormattedMessage } from "react-intl";
import { Button, Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import CurveOptionList from "./CurveOptionList";

function CurveSpeedDefinitionStep({ next, prev, groups, speeds, customSpeeds, products, setProducts }) {
  return (
    <ValidationForm onSubmit={() => {}}>
      <Card className="mt-2">
        <CardHeader>
          <FormattedMessage id="product_wizard.curve_speed_definition" defaultMessage="Curve speed definition" />
        </CardHeader>
        <CardBody>
          <p>
            <FormattedMessage id="product_wizard.select_speeds_curves" defaultMessage="Select speeds for each product’s curves:" />
          </p>
          <CurveOptionList
            groups={groups}
            selectedOptions={speeds.some((v) => v.name === "custom") ? customSpeeds : speeds}
            optionsAppendText=""
            products={products}
            setProducts={setProducts}
            optionsFieldName="speeds"
          ></CurveOptionList>
        </CardBody>
        <CardFooter>
          <Button className="btn btn-outline-dark float-right" onClick={next}>
            <FormattedMessage id="app.next" defaultMessage="Next" />
          </Button>
          <Button className="btn btn-outline-danger" onClick={prev}>
            <i className="fas fa-arrow-left"></i> <FormattedMessage id="app.back" defaultMessage="Back" />
          </Button>
        </CardFooter>
      </Card>
    </ValidationForm>
  );
}

export default CurveSpeedDefinitionStep;
